export const TOGGLE_THEME = 'TOGGLE_THEME';
export const LOAD_JOBS = 'LOAD_JOBS';
export const UPDATE_FILTERS = 'UPDATE_FILTERS';
export const FILTER_JOBS = 'FILTER_JOBS';
export const FETCH_SINGLE_JOB = 'FETCH_SINGLE_JOB';
